import theme from "themes/Theme";
import { IconProps } from "./IconProps";

const ReceivedChartIcon: React.FC<IconProps> = ({
  width = 11,
  height = 7,
  color = theme.palette.custom?.green,
}) => {
  return (
    <svg
      width={width}
      height={height}
      color={color}
      viewBox="0 0 11 7"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.05478 1.41727L10.8823 0.0175781L9.68069 4.89814L8.18175 3.45916L5.76385 5.9778C5.68176 6.06331 5.56836 6.11164 5.44983 6.11164C5.33131 6.11164 5.21791 6.06331 5.13582 5.9778L3.36044 4.12845L0.749304 6.84839C0.582816 7.02181 0.307263 7.02743 0.133838 6.86095C-0.0395861 6.69446 -0.0452096 6.41891 0.121278 6.24548L3.04643 3.19845C3.12851 3.11294 3.24191 3.06461 3.36044 3.06461C3.47897 3.06461 3.59237 3.11294 3.67445 3.19845L5.44983 5.0478L7.55372 2.85626L6.05478 1.41727Z"
        fill={color}
      />
    </svg>
  );
};
export default ReceivedChartIcon;
